import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'expand-widget-dialog',
    templateUrl: './expand-widget-dialog.component.html',
    styleUrls: ['./expand-widget-dialog.component.scss'],
    standalone: false
})
export class ExpandWidgetDialogComponent {
    dialogRef = inject<MatDialogRef<ExpandWidgetDialogComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);


    closeDialog(): void {
        this.dialogRef.close();
    }
}
